module.exports = __webpack_public_path__ + "static/media/work_image005.ddd7cb9b.jpg";